import { useState } from 'react';

const REACTIONS = [
  { type: 'like', emoji: '👍' },
  { type: 'clap', emoji: '👏' },
  { type: 'heart', emoji: '❤️' },
  { type: 'fire', emoji: '🔥' },
];

function ReactionBar({ onReaction, disabled = false }) {
  const [cooldown, setCooldown] = useState(false);

  const handleReaction = (type) => {
    if (cooldown || disabled) return;
    setCooldown(true);
    onReaction(type);
    setTimeout(() => setCooldown(false), 300);
  };

  return (
    <div className="flex gap-2">
      {REACTIONS.map(({ type, emoji }) => (
        <button
          key={type}
          onClick={() => handleReaction(type)}
          disabled={cooldown || disabled}
          className="px-3 py-2 text-xl rounded-lg bg-neutral-100 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 hover:scale-110 active:scale-95 transition-transform disabled:opacity-50 disabled:hover:scale-100"
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}

export { REACTIONS };
export default ReactionBar;
